const MARKET_OPTIONS = [
  { countryCode: "US", currencyCode: "USD", label: "United States" },
  { countryCode: "GB", currencyCode: "GBP", label: "United Kingdom" },
  { countryCode: "CH", currencyCode: "CHF", label: "Switzerland" },
  { countryCode: "DE", currencyCode: "EUR", label: "Germany" },
  { countryCode: "CA", currencyCode: "CAD", label: "Canada" },
  { countryCode: "AU", currencyCode: "AUD", label: "Australia" },
  { countryCode: "NZ", currencyCode: "NZD", label: "New Zealand" },
  { countryCode: "SG", currencyCode: "SGD", label: "Singapore" },
  { countryCode: "HK", currencyCode: "HKD", label: "Hong Kong SAR" },
  { countryCode: "JP", currencyCode: "JPY", label: "Japan" },
  { countryCode: "CN", currencyCode: "CNY", label: "China" },
  { countryCode: "TW", currencyCode: "TWD", label: "Taiwan" },
  { countryCode: "KR", currencyCode: "KRW", label: "South Korea" },
  { countryCode: "IN", currencyCode: "INR", label: "India" },
  { countryCode: "TH", currencyCode: "THB", label: "Thailand" },
  { countryCode: "MY", currencyCode: "MYR", label: "Malaysia" },
  { countryCode: "ID", currencyCode: "IDR", label: "Indonesia" },
  { countryCode: "PH", currencyCode: "PHP", label: "Philippines" },
  { countryCode: "VN", currencyCode: "VND", label: "Vietnam" },
  { countryCode: "AE", currencyCode: "AED", label: "United Arab Emirates" },
  { countryCode: "SA", currencyCode: "SAR", label: "Saudi Arabia" },
  { countryCode: "QA", currencyCode: "QAR", label: "Qatar" },
  { countryCode: "KW", currencyCode: "KWD", label: "Kuwait" },
  { countryCode: "BH", currencyCode: "BHD", label: "Bahrain" },
  { countryCode: "OM", currencyCode: "OMR", label: "Oman" },
  { countryCode: "TR", currencyCode: "TRY", label: "Turkey" },
  { countryCode: "IL", currencyCode: "ILS", label: "Israel" },
  { countryCode: "ZA", currencyCode: "ZAR", label: "South Africa" },
  { countryCode: "EG", currencyCode: "EGP", label: "Egypt" },
  { countryCode: "NG", currencyCode: "NGN", label: "Nigeria" },
  { countryCode: "KE", currencyCode: "KES", label: "Kenya" },
  { countryCode: "MX", currencyCode: "MXN", label: "Mexico" },
  { countryCode: "BR", currencyCode: "BRL", label: "Brazil" },
  { countryCode: "AR", currencyCode: "ARS", label: "Argentina" },
  { countryCode: "CL", currencyCode: "CLP", label: "Chile" },
  { countryCode: "CO", currencyCode: "COP", label: "Colombia" },
  { countryCode: "PE", currencyCode: "PEN", label: "Peru" },
  { countryCode: "SE", currencyCode: "SEK", label: "Sweden" },
  { countryCode: "NO", currencyCode: "NOK", label: "Norway" },
  { countryCode: "DK", currencyCode: "DKK", label: "Denmark" },
  { countryCode: "PL", currencyCode: "PLN", label: "Poland" },
  { countryCode: "CZ", currencyCode: "CZK", label: "Czechia" },
  { countryCode: "HU", currencyCode: "HUF", label: "Hungary" },
  { countryCode: "RO", currencyCode: "RON", label: "Romania" },
  { countryCode: "BG", currencyCode: "BGN", label: "Bulgaria" },
  { countryCode: "UA", currencyCode: "UAH", label: "Ukraine" },
];

const MARKET_BY_COUNTRY = new Map(
  MARKET_OPTIONS.map((item) => [item.countryCode, item]),
);

const getMarketByCountry = (countryCode) => {
  const code = String(countryCode || "").trim().toUpperCase();
  return MARKET_BY_COUNTRY.get(code) || MARKET_BY_COUNTRY.get("US");
};

const getCurrencyForCountry = (countryCode) =>
  getMarketByCountry(countryCode)?.currencyCode || "USD";

export { MARKET_OPTIONS, getCurrencyForCountry, getMarketByCountry };
